export default __webpack_public_path__ + "static/media/hassidout.23c0dbaa.svg";